import React, { useCallback, useEffect, useState } from 'react'
import './styles.scss'
import { distributionTypeLabelMap } from '../constants'
import { useTranslation } from 'react-i18next'

const ChannelFilters = ({
                          channels = [],
                          onFilterTypes = null,
                          onFilterContentUsed = null,
                          selectedTypes = [],
                          selectedContentUsed = [],
                        }) => {
  const contentUsed = ['Pictures', 'Facts', 'Descriptions']
  const [channelTypeCounts, setChannelTypeCounts] = useState({})
  const { t } = useTranslation()
  useEffect(() => {
    const countMap = {}
    for (let i = 0; i < channels.length; i++) {
      for (let j = 0; j < channels[i].types.length; j++) {
        countMap[channels[i].types[j]] = (countMap[channels[i].types[j]] || 0) + 1
      }
    }
    setChannelTypeCounts(countMap)
  }, [channels])
  const filterTypeChange = useCallback(e => {
    const newSelectedTypes = [...selectedTypes]
    if (e.target.checked) {
      newSelectedTypes.push(e.target.value)
    } else {
      newSelectedTypes.splice(newSelectedTypes.indexOf(e.target.value), 1)
    }
    onFilterTypes && onFilterTypes(newSelectedTypes)
  }, [selectedTypes, onFilterTypes])
  const filterContentTypesChange = useCallback(e => {
    const newSelectedContentTypes = [...selectedContentUsed]
    if (e.target.checked) {
      newSelectedContentTypes.push(e.target.value)
    } else {
      newSelectedContentTypes.splice(newSelectedContentTypes.indexOf(e.target.value), 1)
    }
    onFilterContentUsed && onFilterContentUsed(newSelectedContentTypes)
  }, [selectedContentUsed, onFilterContentUsed])
  return (
    <div className="channel-filters">
      <h3 className="channel-filters__header">{t('contentMonitor.channelList.filter.header')}</h3>
      <fieldset className="channel-filters__fieldset">
        <legend className="channel-filters__legend">
          {t('contentMonitor.channelList.filter.channelType.header')}
          <span className="channel-filters__count">{channels.length}</span>
        </legend>
        <ul className="channel-filters__list">
          {
            Object.keys(distributionTypeLabelMap).filter(k => k !== 'All').map(key => {
              return <li className="channel-filters__item" key={key}>
                <label className="channel-filters__label" htmlFor={'filter-' + key}>
                  <input
                    className="channel-filters__input"
                    type="checkbox"
                    id={'filter-' + key}
                    name="channel-type"
                    value={key}
                    checked={selectedTypes.includes(key)}
                    onChange={filterTypeChange}
                  />
                  {t(distributionTypeLabelMap[key])}
                </label>
                <span className="channel-filters__count">{channelTypeCounts[key] || 0}</span>
              </li>
            })
          }
        </ul>
      </fieldset>
      <hr className="channel-filters__separator"/>
      <fieldset className="channel-filters__fieldset">
        <legend className="channel-filters__legend">{t('contentMonitor.channelList.filter.contentUsed.header')}</legend>
        <ul className="channel-filters__list">
          {
            contentUsed.map(type => <li key={type} className="channel-filters__item">
              <label className="channel-filters__label" htmlFor={'filter-' + type}>
                <input
                  onChange={filterContentTypesChange}
                  className="channel-filters__input"
                  type="checkbox"
                  id={'filter-' + type}
                  name="content-type"
                  value={type}
                  checked={selectedContentUsed.includes(type)}
                />
                {type}
              </label>
            </li>)
          }
        </ul>
      </fieldset>
    </div>)
}

export default ChannelFilters
